import { createAction } from 'redux-actions';
import { fetchJson } from '../../shared/helpers/request-helper';
import { UserRecord } from '../../shared/records/user-record';

export const setConfig = createAction('CONTACT/SET_CONFIG', config => config);

export const setErrorMessage = createAction(
  'CONTACT/SET_ERROR_MESSAGE',
  errorMessage => errorMessage
);

export const setSuccessMessage = createAction(
  'CONTACT/SET_SUCCESS_MESSAGE',
  successMessage => successMessage
);

export const userRequestData = createAction('CONTACT/USER_REQUEST_DATA');
export const userReceiveData = createAction('CONTACT/USER_RECEIVE_DATA', user =>
  UserRecord.parse(user));
export const userFailLoadData = createAction('CONTACT/USER_FAIL_LOAD_DATA', error => error);

export const fetchUserData = userId => async (dispatch, getState) => {
  dispatch(userRequestData());

  if (!userId) {
    const error = new Error('Not found user id');
    dispatch(userFailLoadData(error));
    return;
  }

  try {
    const { contact } = getState();
    const config = contact.get('config');

    const url = `${config.SOAR_API_HOST}/user/${userId}`;
    const user = await fetchJson(url);

    dispatch(userReceiveData(user));
  } catch (error) {
    dispatch(userFailLoadData(error));
  }
};
